<template>
  <div
    class="error__wrapper"
    @click="e => $emit('click', e)">
    <error class="error__icon"/>
    <span class="error__text">
      {{ $t('calculator.error-note') }}
    </span>
  </div>
</template>

<script>
import Error from '~/static/img/icons/error.svg';

export default {
  components: {
    Error,
  },
};
</script>

<style lang="scss" scoped>
.error {
  &__wrapper {
    @extend %overlay;
    @extend %centered;
    position: absolute;
    z-index: 1;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 8px;
  }

  &__icon {
    margin-right: 10px;
    fill: map-get($map: $colors, $key: error);
  }

  &__text {
  }
}
</style>
